/** The document kinds Contacts issues: a file kept on a contact (uploaded, or scanned with SAADS Scan). The label is `contacts.documentKinds.CON`. */
const CONTACTS_DOCUMENT_KINDS = ["CON"] as const;
export const contactsDocumentKinds = CONTACTS_DOCUMENT_KINDS.map((kind) => ({ kind, labelKey: `contacts.documentKinds.${kind}` }));
